import { Package, Sun, Zap, Battery, Settings, Building2 } from 'lucide-react';

export const TYPE_ICONS = {
  MODULI: Sun,
  INVERTER: Zap,
  INVERTER_IBRIDO: Zap,
  STORAGE: Battery,
  WALLBOX: Building2,
  CONTATORE_PRODUZIONE: Settings,
  CONTATORE_SCAMBIO: Settings,
  SMART_METER: Settings,
  MONITORAGGIO: Settings,
  DEFAULT: Package,
};

export const getTypeIcon = (typeCode) => {
  const Icon = TYPE_ICONS[typeCode] || TYPE_ICONS.DEFAULT;
  return <Icon className="h-4 w-4" />;
};

export const MAIN_TYPE_CODES = ['MODULI', 'INVERTER', 'INVERTER_IBRIDO', 'STORAGE'];
